import axios from './abstract.service';

export const GetListUnfollowPairs = (params: any): any => {
    return axios.get('pairs/get-unfollow-pair', { params }).then(res => res);
}
export const updateFollowPairStatus = (params: any): any => axios.post('follow-pairs/update-status', params).then(res => res);